import { faMinus, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx";
import { useLayoutEffect, useRef, useState } from "react";

import { T } from "@repo/transifex";

const COLLAPSED_CLAMP_CLASS = "line-clamp-2";

type ProductDescriptionProps = {
  description: string;
};

export const ProductDescription = ({
  description
}: ProductDescriptionProps) => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncatable, setIsTruncatable] = useState(false);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el) return;
    setIsTruncatable(el.scrollHeight > el.clientHeight + 1);
  }, [description]);

  return (
    <div className="flex w-full flex-col items-center gap-4 text-xl">
      <p
        ref={textRef}
        className={clsx("w-full", !isExpanded && COLLAPSED_CLAMP_CLASS)}
        style={
          !isExpanded && isTruncatable
            ? {
                maskImage:
                  "linear-gradient(to bottom, #000 50%, transparent 100%)",
                WebkitMaskImage:
                  "linear-gradient(to bottom, #000 50%, transparent 100%)"
              }
            : undefined
        }
      >
        {description}
      </p>

      {isTruncatable ? (
        <button
          type="button"
          aria-expanded={isExpanded}
          onClick={() => {
            setIsExpanded((prev) => !prev);
          }}
          className="flex items-center gap-2 font-semibold text-kiosk-text-primary"
        >
          {isExpanded ? <T _str="Show less" /> : <T _str="Show more" />}
          <FontAwesomeIcon icon={isExpanded ? faMinus : faPlus} />
        </button>
      ) : null}
    </div>
  );
};
